import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography } from 'seagull';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import styles from './ImpersonateWarning.module.scss';
export default function ImpersonateWarning() {
    const fakeIdentity = useStore(selectors.impersonatingAs);
    const realIdentity = useStore((state)=>{
        var _state_claims;
        return (_state_claims = state.claims) === null || _state_claims === void 0 ? void 0 : _state_claims.email;
    });
    return fakeIdentity && realIdentity ? /*#__PURE__*/ _jsx("div", {
        className: cn(styles.root, 'hide-on-print'),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.content,
            children: /*#__PURE__*/ _jsxs(Typography, {
                variant: "h6",
                ellipsis: true,
                children: [
                    realIdentity,
                    " impersonating as ",
                    fakeIdentity,
                    " - you cannot change anything"
                ]
            })
        })
    }) : null;
}
